import React, { useState } from "react";
import dropdownicon from "../../Assets/Images/AssignUserToRole/dropdownicon.png";

function SearchBar({ onSearch }) {
  const [searchKey, setSearchKey] = useState("");

  // const handleSearchClick = () => {
  //   onSearch(searchKey);
  // };

  return (
    <div className="aur-search-dropbtn">
      <input
        type="text"
        placeholder="Type here to search..."
        value={searchKey}
        onChange={(e) => {
          setSearchKey(e.target.value)
          if(searchKey){
            onSearch(searchKey)
          }
        }}
        style={{ padding: "10px", width: "85%", height: "30px" }}
      />
      <button
        onClick={()=>{onSearch("")}}
        style={{ backgroundColor: "white", border: "none", height:"25px", marginTop:"4px"}}
      >
        <img src={dropdownicon} alt="" />
      </button>
    </div>
  );
}

export default SearchBar;
